import React from "react";
import "./aboutushero.scss";
import Header from "../Header/Header";
import { useNavigate } from "react-router-dom";
const Aboutushero = () => {
  const navigate = useNavigate();
  return (
    <div className="aboutushero_section">
      <div className="aboutushero_content">
        <Header />
        <div className="title_section">
          <div className="title">
            <h2>For the ones who do more than just play the game.</h2>
          </div>
          <button onClick={() => navigate("/signUp")}>
            Join the exclusive club
          </button>
        </div>
      </div>
    </div>
  );
};

export default Aboutushero;
